import React from 'react'
import {
    Form,
  Input,
  Radio,
  Space,Popup,TextArea,
  Button,Swiper,Ellipsis,Image,Grid,NavBar,Tabs,Avatar,Tag,SearchBar,FloatingBubble,Footer,List,ImageViewer
} from 'antd-mobile-v5';
import dayjs from 'dayjs'
import { MessageOutline, LikeOutline,BellOutline,MessageFill,EditSOutline ,SmileOutline} from 'antd-mobile-icons'

import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'
import { useNavigate,useParams,useLocation } from 'react-router-dom';
import { environment } from '../../service/baseUrl';
import {
    GetPostById,SaveUserAction,PostUserAction
  } from '../../service/service';


const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};

class Index extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            id: 0,
            fileList: [],

            visible: false,
            postInfo: {},
            userInfo: {},

            textArea: "",
            userAction: [],
            demoImages: [],
            pId: null,
            pUserName: "",
            visiblePopup: false,
        };
    }

    componentDidMount() {
        var that = this;
        
        const { location } = this.props;
        const { id } = location.state || {}; // 获取 URL 参数
        if (id) {
            that.setState({
                id: id,
            }, () => {
                that.loadUserAction()
            })
            this.GetPostById(id);
        }

        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            return;
        }

        this.setState({
            userInfo: JSON.parse(user)
        })
    }

    GetPostById = (id) => {
        var that = this;
        GetPostById(id).then(res => {
            if (res.success) {
                var result = res.result;
                // result.headImg = environment.apiEndpoint + "/NNFiles/Img/" + result.headImg;
                if (result.headImg != null) {
                    if (result.headImg.indexOf("https://") > -1) {
                        var urls = result.headImg.split("https://").filter(Boolean);
                        result.headImg = urls.length > 0 ? `https://${urls[urls.length - 1]}` : "";
                    } else {
                        result.headImg = environment.apiEndpoint + "/NNFiles/Img/" + result.headImg;
                    }
                }
                var list = [];
                result.imgs.map(item1 => {
                    list.push(environment.apiEndpoint + item1)
                })
                result.imgs = list;
                const creationTime = new Date(result.creationTime);
                const now = new Date();
                const timeDiff = now - creationTime; // 时间差（毫秒）
                result.creationTime = that.formatTimeDifference(timeDiff);

                var cUserActionDto = result.userActionDto;
                result.cangCount = result.userActionDto.filter(action => action.type === 3).length;
                result.zanCount = result.userActionDto
                    .filter(action => action.type === 2 && action.userActionId == null).length;
                result.yanCount = result.userActionDto
                    .filter(action => action.type === 1 && action.userActionId == null).length;
                result.cUserActionDto = cUserActionDto.filter(action => action.type === 1);
                result.yanList = cUserActionDto.filter(action => action.type === 2);
                result.cangList = cUserActionDto.filter(action => action.type === 3);

                result.cUserActionDto.map(item2 => {
                    if (item2.headImg != null) {
                        if (item2.headImg.indexOf("https://") > -1) {
                            var urls = item2.headImg.split("https://").filter(Boolean);
                            item2.headImg = urls.length > 0 ? `https://${urls[urls.length - 1]}` : "";
                        } else {
                            item2.headImg = environment.apiEndpoint + "/NNFiles/Img/" + item2.headImg;
                        }
                    }

                    const creationTime = new Date(item2.creationTime);
                    const now = new Date();
                    const timeDiff = now - creationTime; // 时间差（毫秒）
                    item2.creationTime = that.formatTimeDifference(timeDiff);
                })

                that.setState({
                    imgName: result.headImg,
                    postInfo: result,
                })
            }
        })
    }
    
    loadUserAction = () => {
        var that = this;
        var data = {
            TableType: "Post",
            TableId: this.state.id,
            Type: 1,
        };
        PostUserAction(data).then(res => {
            if (res.success) {
                res.result.map(item => {
                    //item.headImg = environment.apiEndpoint + "/NNFiles/Img/" + item.headImg;
                    if (item.headImg != null) {
                        if (item.headImg.indexOf("https://") > -1) {
                            var urls = item.headImg.split("https://").filter(Boolean);
                            item.headImg = urls.length > 0 ? `https://${urls[urls.length - 1]}` : "";
                        } else {
                            item.headImg = environment.apiEndpoint + "/NNFiles/Img/" + item.headImg;
                        }
                    }

                    const creationTime = new Date(item.creationTime); 
                    const now = new Date();
                    const timeDiff = now - creationTime; // 时间差（毫秒）
                    item.creationTime = that.formatTimeDifference(timeDiff);

                    var cUserActionDto = item.cUserActionDto;
                    item.zanCount = item.cUserActionDto.filter(action => action.type === 2).length;
                    item.yanCount = item.cUserActionDto.filter(action => action.type === 1).length;
                    item.cUserActionDto = cUserActionDto.filter(action => action.type === 1);
                    item.yanList = cUserActionDto.filter(action => action.type === 2);
                    
                    item.cUserActionDto.map(item2 => {
                        if (item2.headImg != null) {
                            if (item2.headImg.indexOf("https://") > -1) {
                                var urls = item2.headImg.split("https://").filter(Boolean);
                                item2.headImg = urls.length > 0 ? `https://${urls[urls.length - 1]}` : "";
                            } else {
                                item2.headImg = environment.apiEndpoint + "/NNFiles/Img/" + item2.headImg;
                            }
                        }
                        
                        const creationTime = new Date(item2.creationTime);
                        const now = new Date();
                        const timeDiff = now - creationTime; // 时间差（毫秒）
                        item2.creationTime = that.formatTimeDifference(timeDiff);
                    })

                })
                that.setState({
                    userAction: res.result
                })
            }
        })
    }

    formatTimeDifference(diffInMs) {
        const diffInSec = Math.floor(diffInMs / 1000);
        const diffInMin = Math.floor(diffInSec / 60);
        const diffInHours = Math.floor(diffInMin / 60);
        const diffInDays = Math.floor(diffInHours / 24);

        if (diffInSec < 1) {
            return "刚刚";
        } else if (diffInMin < 60) {
            return `${diffInMin}分钟前`;
        } else if (diffInHours < 24) {
            return `${Math.max(1, diffInHours)}小时前`; // 不足1小时显示"1小时前"
        } else if (diffInDays < 3) {
            return `${diffInDays}天前`;
        } else {
            // 超过3天显示具体日期（如 "2023-05-15"）
            return new Date(Date.now() - diffInMs).toLocaleDateString("zh-CN");
        }
    }

    submitForm = (data) => {
        var that = this;
        SaveUserAction(data).then(res => {
            if (res.success) {
                that.setState({
                    visiblePopup: false,
                    textArea: "",
                    pUserName: "",
                    pId: null,
                })
                that.loadUserAction();

                if (data.UserActionId == null) {
                    that.GetPostById(that.state.id);
                }
            }
        })
    }
    


    render() {
        

        return (
            <div style={{ height: "100%", width: "100%", overflow: "auto" }}>
                <NavBar back='返回' onBack={() => {
                    this.props.navigate('/posts', { replace: true }); // 传递状态
                }} style={{ 'border-bottom': 'solid 1px #e4e4e4', backgroundColor: "#fff" }}>
                    帖子详情
            </NavBar>


                <ImageViewer.Multi
                    images={this.state.demoImages}
                    visible={this.state.visible}
                    defaultIndex={0}
                    onClose={() => {
                        this.setState({
                            visible: false
                        })
                    }}
                />

                <div style={{ marginBottom: "22%" }}>
                    <div>
                        <Grid columns={5} gap={8}>
                            <Grid.Item span={1}>
                                <div style={{ margin: "12px 0px 6px 12px" }}>
                                    <Avatar src={this.state.postInfo.headImg}
                                        style={{ '--size': '48px', '--border-radius': '35px', 'margin': 'auto' }} />
                                </div>
                            </Grid.Item>
                            <Grid.Item span={4}>
                                <div style={{ height: "100%", paddingTop: "5%" }}>
                                    <div style={{ fontSize: "16px", fontWeight: "600" }}>{this.state.postInfo.creatorUserName}</div>
                                    <div>{this.state.postInfo.creationTime}</div>
                                </div>
                            </Grid.Item>
                        </Grid>
                        <div style={{ padding: "0px 20px 8px 20px", fontSize: "15px" }}>
                            <Ellipsis
                                direction='end'
                                defaultExpanded={true}
                                content={this.state.postInfo.remark}
                                expandText='展开'
                                collapseText='收起'
                            />
                        </div>
                        <div style={{ padding: "0px 20px 4px 20px" }}>
                            <Grid columns={3} gap={8}>
                                {
                                    this.state.postInfo.imgs == null ? null :
                                        this.state.postInfo.imgs.map(item => {
                                            return (
                                                <Grid.Item span={1}>
                                                    <Image onClick={() => {
                                                        this.setState({
                                                            demoImages: this.state.postInfo.imgs,
                                                            visible: true
                                                        })
                                                    }}
                                                        src={item}
                                                        width={"100%"}
                                                        height={110}
                                                        fit='cover'
                                                        style={{ borderRadius: 4 }}
                                                    />
                                                </Grid.Item>);
                                        })
                                }
                            </Grid>
                        </div>
                        <div style={{ marginTop: "6px" }}>
                            <Grid columns={3} gap={8}>
                                <Grid.Item span={1}>
                                    <div style={{ fontSize: "12px", paddingLeft: "20px", fontWeight: "600" }}>
                                        <Space wrap>
                                            <Image src={"https://api.weibinyi.com/images/niannian/1/1-16.png"} fit='fill' width={17} height={17} />
                                            <span>{this.state.postInfo.planetName}</span>
                                        </Space>
                                    </div>
                                </Grid.Item>
                                <Grid.Item span={2}>
                                    <div style={{ fontSize: "15px", paddingRight: "15px", textAlign: "end", lineHeight: "16px" }}>
                                        <Space wrap>
                                            <Image src={"https://api.weibinyi.com/images/niannian/1/1-17.png"}
                                                fit='fill' width={15} height={15} onClick={() => {
                                                    var data = {
                                                        TableId: this.state.id,
                                                        Type: 3,
                                                        TableType: "Post",
                                                    };
                                                    var model = this.state.postInfo.cangList.filter(action =>
                                                        action.creatorUserId === this.state.userInfo.id);
                                                    if (model.length > 0) {
                                                        return;
                                                    }
                                                    this.submitForm(data)
                                                }} />
                                            <span style={{ marginRight: "15px" }} onClick={() => {
                                                var data = {
                                                    TableId: this.state.id,
                                                    Type: 3,
                                                    TableType: "Post",
                                                };
                                                var model = this.state.postInfo.cangList.filter(action =>
                                                    action.creatorUserId === this.state.userInfo.id);
                                                if (model.length > 0) {
                                                    return;
                                                }
                                                this.submitForm(data)
                                            }}>{this.state.postInfo.cangCount}</span>
                                            <Image src={"https://api.weibinyi.com/images/niannian/1/1-18.png"}
                                                fit='fill' width={15} height={15} onClick={() => {
                                                    this.setState({
                                                        visiblePopup: true,
                                                    })
                                                }} />
                                            <span style={{ marginRight: "15px" }} onClick={() => {
                                                this.setState({
                                                    visiblePopup: true,
                                                })
                                            }}>{this.state.postInfo.yanCount}</span>
                                            <Image src={"https://api.weibinyi.com/images/niannian/1/1-20.png"}
                                                fit='fill' width={15} height={15} onClick={() => {
                                                    var data = {
                                                        TableId: this.state.id,
                                                        Type: 2,
                                                        TableType: "Post",
                                                    };
                                                    var model = this.state.postInfo.yanList.filter(action =>
                                                        action.creatorUserId === this.state.userInfo.id);
                                                    if (model.length > 0) {
                                                        return;
                                                    }
                                                    this.submitForm(data)
                                                }} />
                                            <span style={{ marginRight: "15px" }} onClick={() => {
                                                var data = {
                                                    TableId: this.state.id,
                                                    Type: 2,
                                                    TableType: "Post",
                                                };
                                                var model = this.state.postInfo.yanList.filter(action =>
                                                    action.creatorUserId === this.state.userInfo.id);
                                                if (model.length > 0) {
                                                    return;
                                                }
                                                this.submitForm(data)
                                            }}>{this.state.postInfo.zanCount}</span>
                                        </Space>
                                    </div>
                                </Grid.Item>
                            </Grid>
                        </div>
                        <div style={{ marginTop: "0px" }}>
                            <List header=''>
                                {
                                    this.state.userAction.map((item, index) => {
                                        return (<List.Item
                                            key={"1"}
                                            description={
                                                <>
                                                    <Grid columns={6} gap={8}>
                                                        <Grid.Item span={1}>
                                                            <div style={{ marginRight: "10%", float: "right" }}>
                                                                <Image
                                                                    src={item.headImg}
                                                                    style={{ borderRadius: 20 }}
                                                                    fit='cover'
                                                                    width={40}
                                                                    height={40}
                                                                />
                                                            </div>
                                                        </Grid.Item>
                                                        <Grid.Item span={5}>
                                                            <div style={{ fontWeight: "600", color: "#000" }}>
                                                                {item.creatorUserName}
                                                            </div>
                                                            <div style={{ fontWeight: "600", color: "#424242" }}>
                                                                {item.remark}
                                                            </div>
                                                            <div style={{ marginBottom: "10px", marginTop: "5px" }}>
                                                                <Grid columns={6} gap={8}>
                                                                    <Grid.Item span={2}>
                                                                        {item.creationTime}
                                                                    </Grid.Item>
                                                                    <Grid.Item span={1}>
                                                                    </Grid.Item>
                                                                    <Grid.Item span={1}>
                                                                    </Grid.Item>
                                                                    <Grid.Item span={1}>
                                                                        <Image style={{ float: "left", marginTop: "3px" }}
                                                                            src={"https://api.weibinyi.com/images/niannian/1/1-18.png"}
                                                                            fit='fill' width={15} height={15}
                                                                            onClick={() => {
                                                                                this.setState({
                                                                                    visiblePopup: true,
                                                                                    textArea: "",
                                                                                    pUserName: item.creatorUserName,
                                                                                    pId: item.id,
                                                                                })
                                                                            }} />
                                                                        <span style={{ marginLeft: "5px" }}
                                                                            onClick={() => {
                                                                                this.setState({
                                                                                    visiblePopup: true,
                                                                                    textArea: "",
                                                                                    pUserName: item.creatorUserName,
                                                                                    pId: item.id,
                                                                                })
                                                                            }}>{item.yanCount}</span>
                                                                    </Grid.Item>
                                                                    <Grid.Item span={1}>
                                                                        <Image style={{ float: "left", marginTop: "3px" }}
                                                                            src={"https://api.weibinyi.com/images/niannian/1/1-20.png"}
                                                                            fit='fill' width={15} height={15} onClick={() => {
                                                                                var data = {
                                                                                    TableId: this.state.id,
                                                                                    Type: 2,
                                                                                    TableType: "Post",
                                                                                    UserActionId: item.id,
                                                                                };
                                                                                var model = item.yanList.filter(action =>
                                                                                    action.creatorUserId === this.state.userInfo.id);
                                                                                if (model.length > 0) {
                                                                                    return;
                                                                                }
                                                                                this.submitForm(data)
                                                                            }} />
                                                                        <span style={{ marginLeft: "5px" }} onClick={() => {
                                                                            var data = {
                                                                                TableId: this.state.id,
                                                                                Type: 2,
                                                                                TableType: "Post",
                                                                                UserActionId: item.id,
                                                                            };
                                                                            var model = item.yanList.filter(action =>
                                                                                action.creatorUserId === this.state.userInfo.id);
                                                                            if (model.length > 0) {
                                                                                return;
                                                                            }
                                                                            this.submitForm(data)
                                                                        }}>{item.zanCount}</span>
                                                                    </Grid.Item>
                                                                </Grid>
                                                            </div>

                                                            <div>
                                                                {
                                                                    item.cUserActionDto.map(item1 => {
                                                                        return (<>
                                                                            <Grid columns={6} gap={8}>
                                                                                <Grid.Item span={1}>
                                                                                    <Image
                                                                                        src={item1.headImg}
                                                                                        style={{ borderRadius: 20 }}
                                                                                        fit='cover'
                                                                                        width={40}
                                                                                        height={40}
                                                                                    />
                                                                                </Grid.Item>
                                                                                <Grid.Item span={5}>
                                                                                    <div>
                                                                                        <span style={{ marginRight: "5px", color: "#000", fontWeight: "600" }}>
                                                                                            {item1.creatorUserName}
                                                                                        </span>
                                                                                        回复
                                                                                <span style={{ marginLeft: "5px", color: "#000", fontWeight: "600" }}>
                                                                                            {item1.userActionName}
                                                                                        </span>：
                                                                            </div>
                                                                                    <span style={{ fontWeight: "600", color: "#424242" }}>
                                                                                        {item1.remark}
                                                                                    </span>
                                                                                </Grid.Item>
                                                                            </Grid>
                                                                            <div style={{ marginBottom: "10px", marginTop: "5px" }}>
                                                                                <Grid columns={6} gap={8}>
                                                                                    <Grid.Item span={1}>
                                                                                    </Grid.Item>
                                                                                    <Grid.Item span={2}>
                                                                                        {/* 2天前 */}
                                                                                        {item1.creationTime}
                                                                                    </Grid.Item>
                                                                                    <Grid.Item span={1}>
                                                                                    </Grid.Item>

                                                                                </Grid>
                                                                            </div>
                                                                        </>)
                                                                    })
                                                                }
                                                            </div>

                                                        </Grid.Item>
                                                    </Grid>
                                                </>
                                            }
                                        >
                                        </List.Item>)
                                    })
                                }
                            </List>
                            
                            {
                                this.state.userAction.length == 0 ?
                                    <div style={{
                                        textAlign: "center", fontSize: "20px", marginTop: "10%"
                                    }}>
                                        暂无相关信息
                                </div>
                                    : ""
                            }
                        </div>
                      
                    </div>
               
                </div>


                <FloatingBubble
                    axis='xy'
                    magnetic='x'
                    style={{
                        '--initial-position-bottom': '22%',
                        '--initial-position-right': '24px',
                        '--edge-distance': '24px',
                        '--background': '#ffffff00',
                        '--size': '40px'
                    }}
                    onClick={() => {
                        this.setState({
                            visiblePopup: true,
                        })
                    }}
                >
                    {/* <MessageOutline fontSize={26} /> */}
                    <Image src={"https://api.weibinyi.com/images/niannian/1/1-15.png"} fit='fill' width={40} height={40} />
                </FloatingBubble>

                <Popup
                    visible={this.state.visiblePopup}
                    onMaskClick={() => {
                        this.setState({
                            visiblePopup: false,
                        })

                    }}
                    bodyStyle={{
                        borderTopLeftRadius: '18px',
                        borderTopRightRadius: '18px',
                        minHeight: '40vh',
                    }}
                >
                    <div style={{
                        backgroundImage: this.state.titleTab == 0 ?
                            "url('https://api.weibinyi.com/images/niannian/3/5-9-25.png')" : ""
                        , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", minHeight: "40vh"
                    }}>

                        <div className="liuyan" style={{ width: "94%", marginLeft: "3%" }}>
                            <div style={{
                                marginTop: "20px", fontSize: "16px", marginLeft: "5px", fontWeight: "600", marginBottom: "13px"
                            }}>
                                请输入您的留言信息：
                                </div>

                            <div>
                                <TextArea placeholder={this.state.pUserName == ""
                                    ? "请输入您的留言信息" : ('回复：' + this.state.pUserName)}
                                    defaultValue={this.state.textArea}
                                    maxLength={500} rows={6} showCount value={this.state.textArea}
                                    style={{
                                        border: 'solid 1px #c7c7c7', marginTop: '5px', borderRadius: '3%',
                                        marginBottom: '5px', padding: "10px"
                                    }} onChange={(e) => {
                                        this.setState({
                                            textArea: e
                                        })
                                    }}
                                />
                            </div>

                            <div style={{
                                backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/46-10.png')"
                                , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                , marginLeft: "10%", width: "80%", textAlign: "center", fontSize: "17px", lineHeight: "38px"
                                , fontWeight: "600", color: "#fff", marginTop: "15px"
                            }} onClick={() => {
                                var data = {
                                    TableId: this.state.id,
                                    Type: 1,
                                    Remark: this.state.textArea,
                                    TableType: "Post",
                                    UserActionId: this.state.pId,
                                };
                                this.submitForm(data)
                            }}>
                                提 交
                            </div>

                        </div>
                    </div>
                </Popup>

                <BottomMenu position="absolute" selectKey="posts" />

            </div>
        )
    }
}

export default withNavigate(Index);